import { Task, SettingsState } from './types';

const BASE = import.meta.env.VITE_API_URL ?? '';

async function req<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error((err as { error: string }).error ?? res.statusText);
  }
  return res.json();
}

export const api = {
  tasks: {
    list(params?: { filter?: string; source?: string }): Promise<Task[]> {
      const qs = new URLSearchParams();
      if (params?.filter) qs.set('filter', params.filter);
      if (params?.source) qs.set('source', params.source);
      const query = qs.toString() ? `?${qs}` : '';
      return req(`/api/tasks${query}`);
    },
    create(task: Partial<Task>): Promise<Task> {
      return req('/api/tasks', { method: 'POST', body: JSON.stringify(task) });
    },
    update(id: string, patch: Partial<Task>): Promise<Task> {
      return req(`/api/tasks/${id}`, { method: 'PUT', body: JSON.stringify(patch) });
    },
    delete(id: string): Promise<{ success: boolean }> {
      return req(`/api/tasks/${id}`, { method: 'DELETE' });
    },
    reorder(updates: Array<{ id: string; order: number; status?: string }>): Promise<{ updated: number }> {
      return req('/api/tasks/reorder', { method: 'PUT', body: JSON.stringify({ updates }) });
    },
  },

  chat: {
    parse(text: string): Promise<Partial<Task>> {
      return req('/api/chat', { method: 'POST', body: JSON.stringify({ text }) });
    },
  },

  settings: {
    get(): Promise<SettingsState> {
      return req('/api/settings');
    },
  },

  checkReplies(): Promise<{ checked: number; completed: number; message?: string; error?: string }> {
    return req('/api/check-replies', { method: 'POST' });
  },

  importTasks(tasks: Task[]): Promise<{ imported: number; total: number }> {
    return req('/api/import', { method: 'POST', body: JSON.stringify(tasks) });
  },
};
